(function() {
    // 1. Define Data Contract Keys
    const FIRST_SOURCE = 'attr_first_source';
    const FIRST_CAMPAIGN = 'attr_first_campaign';
    const LAST_SOURCE = 'attr_last_source';
    const LAST_CAMPAIGN = 'attr_last_campaign';
    const FULL_JOURNEY = 'attr_utm_journey';
    const CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], .shopify-payment-button, .shopify-payment-button *';

    let lastSyncPayload = '';
    let lastSyncAtMs = 0;

    function getParam(name) {
        return new URLSearchParams(window.location.search).get(name);
    }

    function normalizeSource(rawSource) {
        if (!rawSource) return null;

        const source = rawSource.trim().toLowerCase();
        if (!source) return null;

        if (source === 'meta') return 'facebook';
        if (source === 'ig' || source === 'instagram') return 'instagram';
        if (source === 'pinterestads' || source === 'pin') return 'pinterest';
        return source;
    }

    function inferSourceFromClickIds() {
        const explicitSource = normalizeSource(
            getParam('utm_source') || getParam('source') || getParam('tw_source')
        );
        if (explicitSource) return explicitSource;

        // Pinterest often sends epik/pins_campaign_id even when utm_source is absent.
        if (getParam('epik') || getParam('pins_campaign_id') || getParam('pin_click_id') || getParam('pinterest_click_id')) return 'pinterest';
        if (getParam('gclid')) return 'google';
        if (getParam('fbclid') || getParam('fbc')) return 'facebook';
        if (getParam('msclkid')) return 'bing';
        if (getParam('ttclid')) return 'tiktok';
        if (getParam('twclid')) return 'twitter';
        if (getParam('li_fat_id')) return 'linkedin';

        const referrer = (document.referrer || '').toLowerCase();
        if (referrer.indexOf('pinterest.com') >= 0 || referrer.indexOf('pin.it') >= 0) return 'pinterest';

        return null;
    }

    function inferCampaign() {
        return getParam('utm_campaign') || getParam('tw_campaign') || getParam('pins_campaign_id');
    }

    function buildCartAttributes() {
        return {
            attributes: {
                [FIRST_SOURCE]: localStorage.getItem(FIRST_SOURCE) || '',
                [FIRST_CAMPAIGN]: localStorage.getItem(FIRST_CAMPAIGN) || '',
                [LAST_SOURCE]: localStorage.getItem(LAST_SOURCE) || '',
                [LAST_CAMPAIGN]: localStorage.getItem(LAST_CAMPAIGN) || '',
                [FULL_JOURNEY]: localStorage.getItem(FULL_JOURNEY) || '[]'
            }
        };
    }

    function hasAttributionData() {
        return !!(
            localStorage.getItem(FIRST_SOURCE) ||
            localStorage.getItem(LAST_SOURCE) ||
            localStorage.getItem(FULL_JOURNEY)
        );
    }

    // 2. Parse the URL from the Ad Click
    const currentSource = inferSourceFromClickIds();
    const currentCampaign = inferCampaign();

    // 3. Logic: Update Storage if UTMs exist
    if (currentSource || currentCampaign) {
        const safeSource = normalizeSource(currentSource) || 'unknown';
        const safeCampaign = currentCampaign || 'unknown';
        const nowIso = new Date().toISOString();

        // First Click (Only write if empty)
        if (!localStorage.getItem(FIRST_SOURCE)) {
            localStorage.setItem(FIRST_SOURCE, safeSource);
            localStorage.setItem(FIRST_CAMPAIGN, safeCampaign);
        }
        
        // Last Click (Always overwrite)
        localStorage.setItem(LAST_SOURCE, safeSource);
        localStorage.setItem(LAST_CAMPAIGN, safeCampaign);

        // Full Journey JSON Array
        let journey = [];
        try {
            const existingJourney = localStorage.getItem(FULL_JOURNEY);
            if (existingJourney) journey = JSON.parse(existingJourney);
        } catch (e) { console.error("Failed to parse journey JSON", e); }

        const newTouchpoint = { t: nowIso, s: safeSource, c: safeCampaign };
        const lastTouchpoint = journey[journey.length - 1];
        
        // Only add if the touchpoint is different from the last one
        if (!lastTouchpoint || lastTouchpoint.s !== safeSource || lastTouchpoint.c !== safeCampaign) {
            journey.push(newTouchpoint);
            // Cap at 15 touches to respect Shopify payload limits
            if (journey.length > 15) journey.shift(); 
            localStorage.setItem(FULL_JOURNEY, JSON.stringify(journey));
        }
    }

    // 4. The Payload Injector (Targeting Shopify's AJAX Cart)
    function injectAttributionToCart(force) {
        if (!hasAttributionData()) return;

        const cartAttributes = buildCartAttributes();
        const payload = JSON.stringify(cartAttributes);
        const nowMs = Date.now();

        // Reduce redundant writes while still allowing frequent retries near checkout.
        if (!force && payload === lastSyncPayload && nowMs - lastSyncAtMs < 3000) return;

        lastSyncPayload = payload;
        lastSyncAtMs = nowMs;

        // Fire-and-forget: no await and no checkout delay.
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: payload,
            keepalive: true
        }).catch(function(error) {
            console.error('Attribution sync failed:', error);
        });
    }

    function isCheckoutIntent(target) {
        if (!target || !(target instanceof Element)) return false;
        return !!target.closest(CHECKOUT_SELECTOR);
    }

    // 5. Trigger sync on load and checkout intent events.
    document.addEventListener('DOMContentLoaded', function() {
        // Ensure cart gets recent attribution even if shopper never clicks checkout on this page.
        injectAttributionToCart(false);

        // Delegated listener catches dynamic/express buttons created after page load.
        document.addEventListener('click', function(event) {
            if (isCheckoutIntent(event.target)) {
                injectAttributionToCart(true);
            }
        }, true);

        // Additional non-blocking sync points for SPA/theme interactions.
        document.addEventListener('submit', function() {
            injectAttributionToCart(false);
        }, true);

        document.addEventListener('visibilitychange', function() {
            if (document.visibilityState === 'hidden') injectAttributionToCart(true);
        });

        window.addEventListener('pagehide', function() {
            injectAttributionToCart(true);
        });

        // Retry shortly after load in case cart/session initializes asynchronously.
        window.setTimeout(function() {
            injectAttributionToCart(false);
        }, 1500);
    });
})();